export default __webpack_public_path__ + "assets/images/0d610daf67902cdb0c8f7a936d11a961.png";